import { gql } from '@lcs/shared/api';

export const saveBlockedIpAddressMutation = gql`
   mutation SaveBlockedIpAddress($blockedIpAddress: BlockedIpAddressInput!) {
      blockedIpAddress: saveBlockedIpAddress(blockedIpAddress: $blockedIpAddress) {
         blockedIpAddressId
         ipAddress
         type
         firstSeen
         updateDate
         status
      }
   }
`;
